import './testimonial.scss';
import Swiper from 'swiper/swiper-bundle';

export default () => {
	new Swiper( '.js-testimonial-slider', {
		slidesPerView: 1,
		pagination: {
			el: '.testimonial__dots',
			clickable: true,
		},
	} );
};
